<nav class="f-row">
  <app-icon class="logo-icon" icon="logo"></app-icon>
  <div class="spacer"></div>
  <ul class="nav-list p-0">
    <li class="list-item f-row" id="home" routerLinkActive="tabActive">
      <a class="item f-row" role="tab" [routerLink]="['student-dashboard']" aria-current="page">
        <app-icon icon="house" class="small-icon"></app-icon>
        <span class="text small-medium-text">Home</span>
      </a>
    </li>
    <li class="list-item f-row" id="opportunity" routerLinkActive="tabActive">
      <a class="item f-row" role="tab" [routerLink]="['search-opportunity']" aria-current="page">
        <app-icon icon="search" class="small-icon"></app-icon>
        <span class="text small-medium-text">Search</span>
      </a>
    </li>
    <li class="list-item f-row">
      <a class="item f-row" href="https://www.liberty.edu/osd/lu-serve/cser/tutorials/students/" target="_blank" aria-current="page">
        <app-icon icon="book-open" class="small-icon"></app-icon>
        <span class="text small-medium-text">CSER Tutorials</span>
      </a>
    </li>
    <li class="right-items">
      <button class="custom-button-small-secondary desktop-only" id="credit-progress" attr.aria-label="{{ creditProgressText() }} press enter or click to get more details."
        [routerLink]="['/', 'audit']">
        <app-icon icon="pie-chart" class="x-small-icon"></app-icon>
        <span class="progress-text">{{ creditProgressText() }}</span>
      </button>
      <app-user-dropdown [creditProgressText]="creditProgressText()"></app-user-dropdown>
    </li>
  </ul>
</nav>
